(() => {
  const STORAGE_KEY = 'everword:drawer-offer:gift-bag-kit:dismissed';
  const rootUrl = window.EverwordTheme?.rootUrl || '/';

  const init = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const offer = drawer?.querySelector('[data-drawer-offer]');
    if (!drawer || !offer || offer.dataset.initialized === 'true') return;
    offer.dataset.initialized = 'true';

    const variantId = Number(offer.dataset.variantId || 0);
    const addButton = offer.querySelector('[data-drawer-offer-add]');
    const dismissButton = offer.querySelector('[data-drawer-offer-dismiss]');
    const status = offer.querySelector('[data-drawer-offer-status]');

    const isDismissed = () => {
      try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
    };
    const setDismissed = () => {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    };
    const getCart = async () => {
      const response = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    };
    const syncVisibility = async () => {
      if (!variantId || isDismissed()) { offer.hidden = true; return; }
      try {
        const cart = await getCart();
        const alreadyAdded = cart.items.some(item => Number(item.variant_id) === variantId);
        offer.hidden = cart.item_count === 0 || alreadyAdded;
      } catch (e) {}
    };
    const refreshExistingDrawer = () => {
      const opener = document.querySelector('[data-cart-open]');
      if (opener) opener.click();
    };

    dismissButton?.addEventListener('click', () => {
      setDismissed();
      offer.hidden = true;
      document.dispatchEvent(new CustomEvent('everword:drawer-offer-dismissed', { detail: { variantId } }));
    });

    addButton?.addEventListener('click', async () => {
      if (!variantId || offer.classList.contains('is-busy')) return;
      offer.classList.add('is-busy');
      addButton.disabled = true;
      const originalLabel = addButton.textContent;
      addButton.textContent = 'Adding…';
      if (status) status.textContent = '';
      try {
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Add failed');
        offer.hidden = true;
        if (status) status.textContent = 'Added to your cart.';
        refreshExistingDrawer();
      } catch (e) {
        offer.hidden = false;
        addButton.disabled = false;
        addButton.textContent = originalLabel;
        if (status) status.textContent = 'Couldn’t add this right now. Please try again.';
      } finally {
        offer.classList.remove('is-busy');
      }
    });

    document.querySelectorAll('[data-cart-open]').forEach(trigger => trigger.addEventListener('click', () => window.setTimeout(syncVisibility, 120)));
    syncVisibility();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
